import { Application } from '@hotwired/stimulus'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// CRITICAL: Propagate errors in test environment
// Without this, Stimulus errors are silently swallowed and tests pass incorrectly
// Check for test environment using Rails environment meta tag
if (
  typeof document !== 'undefined' &&
  document.querySelector('meta[name="environment"]')?.content === 'test'
) {
  application.handleError = (error, message, detail) => {
    console.error('Stimulus error:', error, message, detail)
    throw error // Make errors visible and fail tests
  }
}

export { application }
